












    import { PROFILE } from "@/route-names";
import Vue from "vue";
    import { Component, Prop, Watch } from 'vue-property-decorator'

    @Component
    export default  class UserMenuComponent extends Vue {
        profileLink = PROFILE;
        @Prop({ type: Boolean, default: false }) showUserMenu: boolean
        innerShowUserMenu = false
        outside = false;
        isUpdate = false;

        created() {
            this.innerShowUserMenu = this.showUserMenu
        }

        mounted() {
            document.body.addEventListener('click', this.clickOutside.bind(this));
        }
        @Watch('showUserMenu')
        onChangeShowUserMenu() {
            this.outside = true;
            this.isUpdate = true;
        }
        async logout() {             
            let res = await this.$api.AccountService.logoutAsync() 
            if (res) {
                this.$api.SetUser(null);
                this.$router.push({ name: 'login' });
            }
        }
        
        clickOutside(event: any) {
            if (!(this.$el == event.target || this.$el.contains(event.target))) {
                if (this.outside && !this.isUpdate) {
                    this.outside = false;
                    this.$emit('clickOutSideMenu');
                }
                if (this.isUpdate) this.isUpdate = false;
            }
        }
        destroyed() {
            document.body.removeEventListener('click', this.clickOutside.bind(this));
        }
    }
    
